// React Dependencies
import React from 'react';

// External Dependencies
import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';

// Internal Dependencies
import TagsTable from './table';

const TagsList = () => (
  <div>
    <div className="content-header">
      <h1>Tags</h1>
    </div>

    <Link to="/admin/tags/popular" style={{ textDecoration: 'none' }}>
      <Button variant="contained" color="primary" size="medium">Manage Popular Tags</Button>
    </Link>

    <TagsTable />
  </div>
);

export default TagsList;
